<template>
	<NuxtLayout>
		<TextHeader />
		
		<Pagination ref="paginationElement" endpoint="/blog/" :selectedFilters="selectedFilters" @search="data = $event">
			<template #filters-top>
				<h2 v-text="$t('allPosts')"></h2>
				<Filters :data="filtersList" v-model="selectedFilters" @close="filterData" @item-remove="filterData" />
			</template>

			<NuxtLink :to="item.sef" class="blog__ListItem" v-for="(item, index) in data.results" :key="item.id">
				<Flare v-if="item.image" :srcset="item.image" size="both" width="550" height="680" crop="fill" :alt="item.image" :lazy="index <= 2 ? false : true" :fetchPriority="index <= 2 ? 'high' : ''" />
				<h3 v-text="item.title" />
				<time :datetime="item.blog_date" v-text="formatDate(item.blog_date, 'PPP')" />
				<p v-text="item.description" />
			</NuxtLink>

			<template #no-results>
				<p v-text="$t('noResultsBlogs')" />
			</template>
		</Pagination>
	</NuxtLayout>
</template>

<script setup>
	defineOptions({
    auth: 'aminess'
  });
	
	defineProps({
		page: {},
	});

	const { t } = useI18n();
	const { page } = usePage();
	const selectedFilters = ref({});
	const paginationElement = ref(null);
	const data = ref([]);

	const filtersList = [
		{
      title: t('filtersTexts.region'),
      identifier: 'locations',
      items: page?.value?.locations || [],
    },
		{
      title: t('filtersTexts.interests'),
      identifier: 'interests',
      items: page?.value?.interests || [],
    },
	];

	async function filterData() {
		paginationElement.value.filterData();
  }
</script>

<style lang="scss">
	@import url('@/assets/styles/pages/_blogList.scss');
</style>
